<template>
  <section class="section section__content --centered">
    <SectionHeader v-if="content.header" :text="content.header" v-reveal />
    <h1 class="title --main" v-reveal="{ delay: 200 }">{{ content.title }}</h1>
    <p class="description" v-reveal="{ delay: 250 }">{{ content.description }}</p>
    <LangRouterLink
      :to="{ name: 'home' }"
      class="button --top --centered"
      :title="content.label"
      v-reveal="{ delay: 250 }"
    >
      {{ content.label }}
    </LangRouterLink>
  </section>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import { SectionHeader } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'CTAHeaderSection',
  mixins: [DefaultSectionProps],
  components: { LangRouterLink, SectionHeader },
}
</script>
